/* src/app/core/listdialog/listdialog.component.scss */
:root {
  --sh-modal-margin:0px;
}
.dialog-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.5) !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dialog {
  min-height: 150px;
  background-color: #fff !important;
  width: clamp(250px, 30vw, 90vw);
  z-index: 999;
  overflow: hidden;
  outline: 0;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 200px);
  position: relative;
  background-clip: padding-box;
  box-shadow:
    0 16px 24px 2px rgba(0, 0, 0, 0.14),
    0 6px 30px 5px rgba(0, 0, 0, 0.12),
    0 8px 10px -5px rgba(0, 0, 0, 0.3) !important;
}
.dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 35px;
  background: var(--primaryColor);
  box-shadow: 0px 1px 0px var(--primaryColor);
}
.dialog-title {
  text-align: center !important;
  width: 100%;
  font-size: 1rem !important;
  color: #fff !important;
  padding: 10px;
  font-weight: bold;
}
.dialog-body {
  position: relative;
  flex: 1 1 auto;
  padding: 15px;
  overflow-y: auto;
  min-height: 50px;
  max-height: 200px;
  color: #252525 !important;
  font-size: 1rem !important;
  text-align: left;
  padding-top: 15px 15px;
}
.check-list {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-bottom: 5px;
}
.check-list label {
  cursor: pointer;
}
input[type=radio]:checked {
  background-color: #0476af;
}
input[type=radio]:checked:after {
  content: "";
  color: white;
}
input[type=radio] {
  text-align: center;
  display: table-cell;
  vertical-align: middle;
  width: 20px !important;
  height: 20px !important;
  border-radius: 10%;
  border: 1px solid #065a76;
  box-shadow: none;
  font-size: 1em;
}
.dialog-footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: flex-end;
  column-gap: normal;
  padding: 10px;
}
.dialog-footer .btn {
  --bs-btn-line-height:1.2 !important;
  font-size: 0.9rem !important;
  padding: 5px 20px;
  color: #fff;
  background: var(--primaryColor);
  margin-right: 15px;
  border: none;
  cursor: pointer;
}
.dialog-footer .btn:first-child {
  background: #fff;
  color: #363636;
  border: 1px solid #dbdbdb;
}
.dialog-bottom-sheet .dialog-overlay {
  align-items: flex-end;
}
.dialog-full-height .dialog {
  height: calc(100vh - var(--sh-modal-margin) * 2);
}
.dialog-full-screen .dialog {
  min-height: calc(var(--vh, 1vh) * 100);
  max-height: calc(var(--vh, 1vh) * 100);
  width: 100vw;
}
.dialog-half-screen .dialog-overlay {
  justify-content: flex-start;
}
.dialog-half-screen .dialog {
  max-width: 50vw;
  min-height: calc(var(--vh, 1vh) * 100);
  max-height: calc(var(--vh, 1vh) * 100);
}
.reverse .dialog-overlay {
  justify-content: flex-end;
}
.animate.fromleft .dialog {
  transform: translateX(-100%);
  animation: fromleft 0.15s var(--sh-trans-func) 0.15s;
  animation-fill-mode: forwards;
}
.animate.fromright .dialog {
  transform: translateX(100%);
  animation: fromright 0.15s var(--sh-trans-func) 0.15s;
  animation-fill-mode: forwards;
}
.animate.fromtop .dialog {
  transform: translateY(-100%);
  animation: fromtop 0.15s var(--sh-trans-func) 0.15s;
  animation-fill-mode: forwards;
}
.animate.frombottom .dialog {
  transform: translateY(100%);
  animation: frombottom 0.15s var(--sh-trans-func) 0.15s;
  animation-fill-mode: forwards;
}
@keyframes fromleft {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes fromright {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes frombottom {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}
@keyframes fromtop {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}
/*# sourceMappingURL=listdialog.component.css.map */
